import type { ComponentType, ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface EmptyStateProps {
  icon?: ComponentType<{ className?: string }>;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  testId?: string;
  className?: string;
}

/**
 * Estado vacío estándar (UI-STD-1): icono atenuado, título y explicación.
 * No introduce copy: recibe textos ya traducidos por la app.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  testId,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 py-10 text-center',
        className,
      )}
      data-testid={testId}
    >
      {Icon && (
        <Icon
          className="h-10 w-10 text-muted-foreground"
          aria-hidden="true"
        />
      )}
      <div className="font-medium">{title}</div>
      {description && (
        <p className="max-w-md text-sm text-muted-foreground">{description}</p>
      )}
      {action}
    </div>
  );
}
